import { Helmet, HelmetData } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type HeadProps = {
  title?: string;
  description?: string;
};

const helmetData = new HelmetData({});

export const Head = ({ title = '', description = '' }: HeadProps = {}) => {
  const { t } = useTranslation();
  const appName = t('common.appName');

  return (
    <Helmet
      helmetData={helmetData}
      title={title ? `${title} | ${appName}` : undefined}
      defaultTitle={appName}
    >
      <meta name='description' content={description} />
    </Helmet>
  );
};
